require('!!raw-loader!/builds/654284/v2/src/index.html');